import { all, fork } from 'redux-saga/effects';
import { watchFetchMyFavoriteData } from 'redux/sagas/components/myFavorite.saga';
import { watchResources } from 'redux/sagas/resources.saga';
import { watchSystemSaga } from './system/saga';

export const rootSagas = function * root () {
  yield all([
    fork(watchFetchMyFavoriteData),
    fork(watchResources),
    fork(watchSystemSaga)
  ]);
};
